import styled from "styled-components";
import { sm } from "../../../BreakPoints";

export const Page = styled.main`
  min-height: 100vh;
  padding: 3.9rem 1rem 1.4rem;
  background: linear-gradient(180deg, var(--ice-blue) 0%, var(--surface-white) 100%);
`;

export const Container = styled.section`
  max-width: 980px;
  margin: 0 auto;
  background: var(--surface-white);
  border: 1px solid var(--line-mid);
  border-radius: 0.6rem;
  padding: 1.2rem 1.3rem;
  box-shadow: 0 8px 16px rgba(18, 45, 96, 0.08);

  ${sm({
    padding: "1rem 0.8rem",
  })}
`;

export const Title = styled.h1`
  font-size: 1.6rem;
  color: var(--deep-navy);
`;

export const UpdatedText = styled.p`
  margin-top: 0.35rem;
  color: var(--text-muted);
  font-size: 0.82rem;
`;

export const Intro = styled.p`
  margin-top: 1rem;
  color: var(--text-muted);
  font-size: 0.9rem;
  line-height: 1.7;
`;

export const Section = styled.section`
  margin-top: 1rem;
  padding-top: 0.85rem;
  border-top: 1px solid var(--line-soft);
`;

export const SectionTitle = styled.h2`
  font-size: 1rem;
  color: var(--deep-navy);
`;

export const Text = styled.p`
  margin-top: 0.45rem;
  color: var(--text-muted);
  font-size: 0.87rem;
  line-height: 1.65;
`;

export const BulletList = styled.ul`
  margin: 0.5rem 0 0;
  padding-left: 1rem;
  display: grid;
  gap: 0.25rem;
`;

export const Bullet = styled.li`
  color: var(--text-muted);
  font-size: 0.86rem;
  line-height: 1.6;
`;
